// Who is signed in, for the helpers that are not React (nodeAccess.isOwner,
// the signing panel's "me", the scope checks of a file's menu). The session
// itself is @zehnmindai/embed's SessionProvider (`GET /api/v1/auth/me`
// through docs' BFF cookie); SessionGate copies the person here before any
// screen renders, and React code reads useSession() directly. Memory only:
// nothing about the person is kept in storage.

import { holdsScope, isBreakGlassAdmin } from './scopes.js';

let current = null;

/** SessionGate: the person useSession() reports, with their scopes (null: nobody). */
export function setSignedIn(user, scopes = []) {
  current = user ? { ...user, scopes: Array.isArray(scopes) ? [...scopes] : [] } : null;
}

/** `{uuid, personId, displayName, email, language, kind, scopes}`, or null. */
export const currentUser = () => current;

/** docs' uuid of the signed-in person (what `owner_uuid`, `user_uuid` name), or null. */
export const currentUserUuid = () => current?.uuid ?? null;

/** The signed-in person's scopes in docs. */
export const currentScopes = () => current?.scopes ?? [];

/** Whether the signed-in person holds `scope` (one or a list); the break-glass admin holds every one. */
export const iHold = (scope) => holdsScope(currentScopes(), scope, { admin: isBreakGlassAdmin(current) });
